import { RadarEvent, RadarEventProperties } from './events';

type RadarTracker = {
  track: (trackEvent: RadarEvent) => void;
};

interface RadarInstance {
  track: <T extends RadarEvent['eventName']>(event: T, properties?: RadarEventProperties<T>) => void;
}

declare global {
  interface Window {
    Radar?: RadarInstance;
  }
}

export const useRadarTracker = (): RadarTracker => {
  const track = (trackEvent: RadarEvent) => {
    if (window.Radar != null) {
      window.Radar.track(trackEvent.eventName, trackEvent.properties);
    }
  };

  return {
    track,
  };
};
